<template>
  <!-- 1.移动端 -->
  <!-- 2.微信 -->
  <!-- 3.fetchWeiXinConfig成功获取签名 -->
  <!-- 4.type为小程序 -->
  <!-- 5.满足以上所有条件，才能展示跳转小程序的卡片 -->
    <div class="jsonBox">
      <div v-if="chatDataCenter.chatTerminal == 'H5' && isWeixin && chatDataCenter.wxJssdk && jsonContent.type === 'wxapp'">
        <wx-open-launch-weapp
          :username="jsonContent.data.appId"
          :path="renderPathAndParams()"
          @ready="doReady"
          @launch="doLaunch"
          @error="doError"
        >
          <script type="text/wxtag-template">
            <style>
              .box{
                width: 230px;
                background: white;
                padding: 8px 15px;
                margin-top: 15px;
                border-radius: 8px;
                cursor: pointer;
              }
              .box-title{
                font-size: 14px;
              }
              .box-content{
                display: flex;
                margin-top: 10px;
              }
              .box-desc{
                font-size: 12px;
                color: #8D8D8D;
                width: calc(100% - 45px);
              }
              .box-img{
                width: 32px;
                height: 32px;
                margin-left: 10px;
              }
            </style>
            <div class="box">
              <div class="box-title">{{jsonContent.data.title}}</div>
              <div class="box-content">
                <div class="box-desc">{{jsonContent.data.desc}}</div>
                <img class="box-img" :src="jsonContent.data.imgUrl" />
              </div>
            </div>
          </script>
        </wx-open-launch-weapp>
      </div>
      <div class="box" @click="toJump" v-else>
        <div class="box-title">{{jsonContent.data.title}}</div>
        <div class="box-content">
          <div class="box-desc">{{jsonContent.data.desc}}</div>
          <img class="box-img" :src="jsonContent.data.imgUrl" />
        </div>
      </div>

    </div>
</template>

<script>
    import chatDataCenter from "../../jsSdk/chatDataCenter";

    export default {
      name: "jsonCard",
      props:['message'],
      created() {
        this.isWeixin = common.isWx()
        console.log('是否是微信', this.isWeixin)
      },
      mounted() {
        if(chatDataCenter.isJSON(this.message.messageContent)){
          var content=JSON.parse(this.message.messageContent);
          if(chatDataCenter.isJSON(content.plainText)){
            const jsonContent = JSON.parse(content.plainText)
            this.jsonContent = jsonContent;
          }
        }

      },
      data(){
        return{
          jsonContent:{
            type:"",
            data: {
              appId: "",
              path: "",
              guide: "",
              title: "",
              desc: "",
              imgUrl: "",
              link: "",
              params: {}
            }
          },
          isWeixin:false,
          chatDataCenter
        }
      },
      methods:{
        toJump(){
          const jsonContent = this.jsonContent
          const that = this;

          switch (jsonContent.type) {
            case "wxapp":
              if(common.isWx()){
                that.$messageBox.Error({
                  message: "跳转失败",
                  duration: 3000,
                });
              }else {
                that.$messageBox.Error({
                  message: "无法跳转到微信小程序，请在微信内咨询",
                  duration: 3000,
                });
              }
              console.log(that.renderPathAndParams())
              break;
            case "web":
              let url = jsonContent.data.link;
              if(jsonContent.data.params){
                if(url.indexOf('?') === -1){
                  url += '?'+this.getParams(jsonContent.data.params)
                }else {
                  url += '&'+this.getParams(jsonContent.data.params)
                }
              }
              console.log(url)
              window.open(url, "_blank");
              break;
            case "app":
              break;
          }
        },
        doReady(){
          console.log('ready')
        },
        doLaunch(e){
          console.log('launch',e)
        },
        doError(e){
          this.$messageBox.Error({
            message: "跳转失败",
            duration: 3000,
          });
        },
        renderPathAndParams(){
          const jsonContent = this.jsonContent
          let url = jsonContent.data.path;
          if(jsonContent.data.params){
            if(url.indexOf('?') === -1){
              url += '?'+this.getParams(jsonContent.data.params)
            }else {
              url += '&'+this.getParams(jsonContent.data.params)
            }
          }
          return url
        },
        getParams: function(params) {
          var arr = [];
          for (var name in params) {
            arr.push(
              encodeURIComponent(name) + "=" + encodeURIComponent(params[name])
            );
          }
          return arr.join("&");
        },
      }
    }
</script>

<style scoped>
  .jsonBox{
    width: 100%;
    float: left;
  }
  .box{
    width: 230px;
    background: white;
    padding: 8px 15px;
    margin-top: 15px;
    border-radius: 8px;
    cursor: pointer;
  }
  .box-title{
    font-size: 14px;
  }
  .box-content{
    display: flex;
    margin-top: 10px;
  }
  .box-desc{
    font-size: 12px;
    color: #8D8D8D;
    width: calc(100% - 45px);
  }
  .box-img{
    width: 32px;
    height: 32px;
    margin-left: 10px;
  }
</style>
